<div class="flex flex-col min-h-screen">
  <header>
    <reza-header />
    @if (!hideNavbar) {
      <reza-navbar />
    }
  </header>
  @if (!hideBreadcrumb) {
    @if (breadcrumbs$ | async; as breadcrumbs) {
      <ui-wrapper class="pt-8">
        <page-settings-breadcrumbs [breadcrumbs]="breadcrumbs" />
      </ui-wrapper>
    }
  }
  <main class="flex-1 mb-4">
    <ui-wrapper>
      <ui-router-outlet />
    </ui-wrapper>
  </main>
  <footer>
    <reza-footer [publicFooter]="publicFooter" />
    <!-- <button (click)="startCountdown()">click me</button> -->
  </footer>
</div>
<!-- <button (click)="startCountdown()">startSessionCountdown</button> -->
